module.exports = __webpack_public_path__ + "static/media/zeya_folds_herarms01.633fe006.png";